import { useState, useEffect } from 'react'
import { Navbar, Container, Row, Carousel, Button, Col, Card, Modal, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'
import { Select, Space } from 'antd'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { MenuItem } from '../../../../../_metronic/layout/components/header/MenuItem'
import { MenuItemSite } from '../../../../../_metronic/layout/components/header/MenuItemSite'
import axios from 'axios'
import MyLineChart2 from '../.././MyLineChart2'
import WeekSelect from '../.././WeekSelect'
import clsx from 'clsx'
import { checkIsActive } from '../../../../../_metronic/helpers'
import { useLocation, useNavigate } from 'react-router'
import BluedotNewsfeedDropdown from '../../../home/components/BluedotNewsfeedDropdown'
import EuropeMap from '../../EuropeMaps'
import moment from 'moment'
import { useSelectedWeek } from '../../../../contexts/SelectedWeekContext'
interface ItemType {
  id: number
  title: string
  campaigns: number
  path: string
  bgColor: string
}
//\_metronic\partials\layout\header-menus\HeaderUserMenuPublic.tsx
const NavSlider = () => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const items: ItemType[] = [
    {
      id: 1,
      title: 'Google trends',
      campaigns: 4,
      path: 'google-trends',
      bgColor: '#6441A5',
    },
    {
      id: 2,
      title: 'Pharmacy sales - Drugs associated with Respiratory Syndromes',
      campaigns: 4,
      path: 'pharmacy-sales',
      bgColor: '#6441A5',
    },

    {
      id: 3,
      title: 'Doctor visits for Respiratory Syndromes',
      campaigns: 4,
      path: 'doctor-visits',
      bgColor: '#6441A5',
    },
    {
      id: 4,
      title: 'Hospital admissions for SARI',
      campaigns: 4,
      path: 'hospital-adminssions',
      bgColor: '#6441A5',
    },

    {
      id: 5,
      title: 'Deaths for Covid-19',
      campaigns: 4,
      path: 'deaths-for-covid',
      bgColor: '#6441A5',
    },
    {
      id: 6,
      title: 'Respiratory viruses positivity rate',
      campaigns: 4,
      path: 'viruses-positivity-rate',
      bgColor: '#6441A5',
    },

    {
      id: 7,
      title: 'Viral Load in wastewater - Covid-19',
      campaigns: 4,
      path: 'viral-load-in-wastewater',
      bgColor: '#6441A5',
    },

    // Add more items as needed
  ]
  const { pathname } = useLocation()

  const [itemsPerSlide, setItemsPerSlide] = useState(6)
  const [totalItems, setTotalItems] = useState<ItemType[][]>([]) // Specify the type here
  const [activeIndex, setActiveIndex] = useState(0)
  const [hoveredItem, setHoveredItem] = useState<number | null>(null) // Specify the type here

  const handleHover = (itemId: number, isHovered: boolean) => {
    setHoveredItem(isHovered ? itemId : null)
  }
  function getItemIdByPath(items: ItemType[], pathToCheck: string): number {
    const foundItem = items.find((item) => '/ge/' + item.path === pathToCheck)

    return foundItem ? foundItem.id : 0
  }

  useEffect(() => {
    const updateItemsPerSlide = () => {
      const screenWidth = window.innerWidth
      const itemId = getItemIdByPath(items, pathname)
      if (screenWidth <= 650) {
        if (itemId <= 2) {
          setActiveIndex(0)
        } else if (itemId == 3 || itemId == 4) {
          setActiveIndex(1)
        } else if (itemId == 5 || itemId == 6) {
          setActiveIndex(2)
        } else if (itemId == 7 || itemId == 8) {
          setActiveIndex(3)
        } else {
          // activeIndex = 4

          setActiveIndex(4)
        }
        setItemsPerSlide(2)
      } else if (screenWidth <= 980) {
        if (itemId / 4 <= 1) {
          setActiveIndex(0)
        } else if (itemId / 4 <= 2) {
          setActiveIndex(1)
        } else {
          setActiveIndex(2)
        }
        setItemsPerSlide(4)
      } else {
        if (itemId < 7) {
          setActiveIndex(0)
        } else {
          setActiveIndex(1)
        }
        setItemsPerSlide(6)
      }
    }

    updateItemsPerSlide()

    window.addEventListener('resize', updateItemsPerSlide)

    return () => {
      window.removeEventListener('resize', updateItemsPerSlide)
    }
  }, [])

  useEffect(() => {
    setTotalItems(
      [...Array(Math.ceil(items.length / itemsPerSlide))].map((_, i) =>
        items.slice(i * itemsPerSlide, (i + 1) * itemsPerSlide)
      )
    )
  }, [items, itemsPerSlide])

  const handlePrevClick = () => {
    setActiveIndex((prevIndex) => Math.max(0, prevIndex - 1))
  }

  const handleNextClick = () => {
    setActiveIndex((prevIndex) => Math.min(totalItems.length - 1, prevIndex + 1))
  }

  return (
    <div className='p-0 app-header-slider d-flex justify-content-center align-items-center flex-stack'>
      {/* Slider Navigation Buttons */}
      <Button
        className='btn btn-icon btn-color-red btn-active-color-primary ms-xxl-n18'
        variant='light'
        disabled={activeIndex === 0}
        onClick={handlePrevClick}
      >
        <BsChevronLeft size={20} />
      </Button>
      {/* Header Slider */}
      <Carousel
        className=' d-flex justify-content-center align-items-center w-100'
        interval={null}
        wrap={false}
        controls={false}
        activeIndex={activeIndex}
        indicators={false}
        onSelect={(index) => setActiveIndex(index)}
      >
        {totalItems.map((slideItems, slideIndex) => (
          <Carousel.Item key={slideIndex}>
            <div
              className='m-3  d-flex justify-content-center align-items-center'
              style={{ gap: 20 }}
            >
              {slideItems.map((item) => (
                <MenuItem title={item.title} to={item.path} />
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
      {/* Slider Navigation Buttons */}
      <Button
        className='btn btn-icon btn-color-red btn-active-color-primary me-xxl-n18'
        variant='light'
        disabled={activeIndex === totalItems.length - 1}
        onClick={handleNextClick}
      >
        <BsChevronRight size={20} />
      </Button>
    </div>
  )
}
const EuropModal = ({ showModal, handleClose }) => {
  return (
    <Modal size='lg' centered show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Europe</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EuropeMap />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
function FixedNavbar() {
  const [showModal, setShowModal] = useState(false)

  const handleShow = () => setShowModal(true)
  const handleClose = () => setShowModal(false)
  const { Option } = Select
  const handleChange = (value) => {
    // Handle language change logic here
  }
  return (
    <Navbar fixed='top' className=' bg-gray-300 '>
      <Container className='px-0'>
        <Navbar.Brand style={{ marginLeft: '-2.2%' }} className='text-primary fw-bold ' href='/fr'>
          AIOLOS-dashboard.com
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='navbarSupportedContent' />

        <div style={{ marginRight: '-2.2%' }}>
          <Space className='mx-10'>
            <div>
              {/* <Button variant='primary' onClick={handleShow}>
                <i className='fa-solid fa-earth-europe'></i>Map
              </Button> */}

              <EuropModal showModal={showModal} handleClose={handleClose} />
            </div>
            <div>
              <BluedotNewsfeedDropdown />
            </div>

            <Select
              variant='borderless'
              size={'large'}
              defaultValue='en'
              style={{ width: 100 }}
              onChange={handleChange}
            >
              <Option value='en'>English</Option>
              <Option value='fr'>French</Option>
              <Option value='ge'>Deutsch</Option>
              {/* Add more language options as needed */}
            </Select>
          </Space>

          <img
            style={{ width: '80px', marginRight: '-6%' }}
            alt='logo'
            src={toAbsoluteUrl('/media/logos/ailos-logo.png')}
          />
        </div>
      </Container>
    </Navbar>
  )
}

function ScrollNavbar() {
  return (
    <Navbar fixed='top' className='bg-secondary navbar-dark justify-content-center'>
      <Row className='d-flex '>
        <Col md={12}>
          <FixedNavbar />
        </Col>
        <Col md={12} className='p-4 mt-20'>
          <Container>
            <NavSlider />
          </Container>
        </Col>
      </Row>
    </Navbar>
  )
}
interface WeeklyData {
  week: string | null
}
interface googleTrendsRsAlerts extends WeeklyData {
  dataGraph: number
}
interface drugSalesRSAlerts extends WeeklyData {
  dataGraph: number
}
interface consultationNumberRsAlerts extends WeeklyData {
  dataGraph: number
}
interface hospitalAdmissionsSariAlerts extends WeeklyData {
  dataGraph: number
}
interface covid19DeathsAlerts extends WeeklyData {
  dataGraph: number
}
interface respiratoryVirusPositivityRatesAlerts extends WeeklyData {
  dataGraph: number
}
interface wastewaterViralLoadCovid19GeAlerts extends WeeklyData {
  dataGraph: number
}
interface Data {
  googleTrendsRsAlerts: googleTrendsRsAlerts[]
  drugSalesRSAlerts: drugSalesRSAlerts[]
  consultationNumberRsAlerts: consultationNumberRsAlerts[]
  hospitalAdmissionsSariAlerts: hospitalAdmissionsSariAlerts[]
  covid19DeathsAlerts: covid19DeathsAlerts[]
  respiratoryVirusPositivityRatesAlerts: respiratoryVirusPositivityRatesAlerts[]
  wastewaterViralLoadCovid19GeAlerts: wastewaterViralLoadCovid19GeAlerts[]
}
interface DataEntry {
  x: string
  y: string | number
}
export function GeHomeHeader() {
  const [showScrollNavbar, setShowScrollNavbar] = useState(false)
  const { pathname } = useLocation()
  let navigate = useNavigate()
  const { Option } = Select
  const handleChange = (value) => {
    // Handle language change logic here
  }
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop
      setShowScrollNavbar(scrollPosition > 100)
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  const [hoveredCard, setHoveredCard] = useState(null)

  const handleMouseEnter = (index) => {
    setHoveredCard(index)
  }

  const handleMouseLeave = () => {
    setHoveredCard(null)
  }
  function roundToDecimal(num: number, decimalPlaces: number): number {
    const multiplier = Math.pow(10, decimalPlaces)
    return Math.round(num * multiplier) / multiplier
  }
  const [dataGraph, setDataGraph] = useState<Data | null>(null)
  // const [alertData, setAlertData] = useState<Data | null>(null)
  const API_URL = process.env.REACT_APP_API_URL
  const { selectedWeek, setSelectedWeek } = useSelectedWeek('2023-W40')
  function getAlertedAgeClasses(
    data:
      | Data2["consultationNumber"]
      | Data2["hospitalAdmission"]
      | Data2["covidDeath"]
      | null
  ): string[] | null {
    if (!data) {
      return null // Return null if data is undefined
    }

    const alertedAgeClassesSet: Set<string> = new Set()

    for (const entry of data) {
      if (entry.alertVirus === 1) {
        alertedAgeClassesSet.add(entry.ageGroup)
      }
    }

    // Convert the Set back to an array
    return Array.from(alertedAgeClassesSet)
  }
  function getPreviousWeek(currentWeek, numPreviousWeeks) {
    // Parse the input string into a moment object
    const currentDate = moment(currentWeek, 'YYYY-[W]WW')

    // Subtract the specified number of weeks from the current date
    const previousWeek = currentDate.clone().subtract(numPreviousWeeks, 'weeks')

    // Get the year and week number from the moment object
    const prevYear = previousWeek.format('YYYY')
    const prevWeekNum = previousWeek.format('W')

    // Format week number to be 'W1' instead of 'W01' for the first week
    const formattedWeekNum = prevWeekNum.replace(/^0+/, '') // Remove leading zeros

    // Format and return the previous week
    return `${prevYear}-W${formattedWeekNum}`
  }
  interface Data2 {
    googleTrends: { week: string; alertVirus: string }[];
    drugSales: { week: string; alertVirus: number }[];
    consultationNumber: { week: string; ageGroup: string; alertVirus: number }[];
    hospitalAdmission: any[];
    covidDeath: any[];
  }
  const [alertData, setAlertData] = useState<Data2 | null>(null);
  function processData(
    dataTabGraph: (
      | googleTrendsRsAlerts
      | drugSalesRSAlerts
      | consultationNumberRsAlerts
      | hospitalAdmissionsSariAlerts
      | covid19DeathsAlerts
      | respiratoryVirusPositivityRatesAlerts
      | wastewaterViralLoadCovid19GeAlerts
    )[],
    selectedWeek: string
  ): DataEntry[] {
    const processedData: DataEntry[] = []
    const weeksToCheck: number[] = [2, 1, 0] // To get the previous weeks in reverse order

    weeksToCheck.forEach((weekOffset, index) => {
      const xValue: string = getPreviousWeek(selectedWeek, weekOffset)
      let yValue: string | number = '0'
      const foundData = dataTabGraph.find((data: any) => data.week === xValue) // Using type assertion here
      if (foundData) {
        yValue = roundToDecimal(Number(foundData.dataGraph), 2)
      }
      processedData.push({ x: xValue, y: yValue })
    })

    return processedData
  }
  useEffect(() => {
    const fetchData = async (week = selectedWeek) => {
      try {
        const response = await axios.get(API_URL + `/trendsPreviousWeek?week=${week}`)
        setDataGraph(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
        // Handle error or set a default value for data
        setDataGraph(null)
      }
    }
    const fetchAlertData = async (week = selectedWeek) => {
      try {
        const response = await axios.get(API_URL + `/alertsGe?week=${week}`)
        setAlertData(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
        setAlertData(null)
      }
    }

    fetchData(selectedWeek)
    fetchAlertData(selectedWeek)

  }, [selectedWeek])
  return (
    <>
      <div className='row p-3'>
        <FixedNavbar />
        {showScrollNavbar ? <ScrollNavbar /> : null}
        <Card className=' mt-20  mb-6 '>
          <Card.Body className='row  justify-content-center pb-0'>
            <Card.Title className='mx-10'>
              <WeekSelect />

              <h1 className='mt-5'>
                {' '}
                Situation of acute respiratory infections in France – 2025-2026
              </h1>
              <div className='d-flex mt-5 justify-content-start my-4'>
                <div>
                  <MenuItemSite title={'FRANCE'} to={'/fr'} />
                </div>
                <div>
                  <MenuItemSite title={'GERMANY'} to={'/ge'} />
                </div>
              </div>
            </Card.Title>
            {/* <MySlider /> */}
            <div className='d-flex w-100 justify-content-center'>
              <div
                className=' align-self-center justify-content-center align-items-center
              overflow-x-scroll overflow-y-hidden ' // style={{whiteSpace: 'nowrap'}}
              >
                <Col
                  xs={12}
                  style={{ maxWidth: '1450px', width: '1450px' }}
                  className='row  justify-content-center p-0 mt-6 mb-6 grid gap-2'
                >
                  <Card style={{ width: '10%' }} className='bg-primary bg-opacity-10 col-md-1'>
                    <Card.Body className='row  p-2  justify-content-center'>
                      <Card.Title className='text-center align-items-center mt-5'>
                        Social media
                      </Card.Title>
                      <Card
                        className={clsx(
                          hoveredCard === '1'
                            ? 'menu-item   p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                            : 'menu-item  p-3  text-center  menu-link  ',
                          {
                            'bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                              checkIsActive(pathname, 'google-trends'),
                          }
                        )}
                        onMouseEnter={() => handleMouseEnter('1')}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => navigate('google-trends')}
                      >
                        <Card.Body
                          style={{ minHeight: '235.5px' }}
                          className='row  p-0  justify-content-center'
                        >
                          <Card.Subtitle className='mb-15  text-muted'>
                            {/* <div>
                          <i
                            style={{color: 'orange', transform: 'rotate(-15deg)'}}
                            className='  fa-solid fa-arrow-right '
                          ></i>
                          <i style={{color: 'red'}}></i>
                        </div> */}
                            <p>Google trends</p>
                            {/* <div className='row'>
                              {(() => {
                                const alertCount =
                                  alertData?.googleTrends.filter(
                                    (entry) => entry.alertVirus === '1.00'
                                  ).length || 0

                                if (alertCount > 3) {
                                  return (
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{show: 250, hide: 400}}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          <i style={{color: 'red'}}>More than 3 symptoms</i>
                                        </Tooltip>
                                      }
                                    >
                                      <i style={{color: 'red'}} className='fa-solid fa-bell'></i>
                                    </OverlayTrigger>
                                  )
                                } else if (alertCount > 0) {
                                  return (
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{show: 250, hide: 400}}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          <i style={{color: '#FF8400'}}>1 to 3 symptoms</i>
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        style={{color: '#FF8400'}}
                                        className='fa-solid fa-bell'
                                      ></i>
                                    </OverlayTrigger>
                                  )
                                } else {
                                  return (
                                    <div className='row'>
                                      <i className='fa-solid fa-bell opacity-0'></i>
                                    </div>
                                  )
                                }
                              })()}
                            </div> */}
                            <div className='row'>
                              <i className='fa-solid fa-bell opacity-0'></i>
                            </div>
                          </Card.Subtitle>
                          <Col className=''>
                            <MyLineChart2
                              data={
                                dataGraph
                                  ? [
                                    {
                                      id: 'googleTrendsRsAlerts',
                                      data: processData(
                                        dataGraph.googleTrendsRsAlerts,
                                        selectedWeek
                                      ),
                                    },
                                  ]
                                  : []
                              }
                            />
                          </Col>
                        </Card.Body>
                      </Card>
                    </Card.Body>
                  </Card>
                  <Card style={{ width: '20%' }} className='bg-primary  bg-opacity-10  col-md-4 '>
                    <Card.Title
                      style={{
                        width: '104%',
                        marginLeft: '-2%',
                        marginTop: '9px',
                        marginBottom: '-0.1%',
                      }}
                      className='text-center  bg-primary rounded bg-opacity-0 p-4'
                    >
                      Ambulatory care
                    </Card.Title>
                    {/* <Card.Title
                  style={{width: '104%', marginLeft: '-2%'}}
                  className='text-center text-white  bg-primary rounded  p-4'
                >
                  Virology
                </Card.Title> */}
                    <Card.Body className='row  p-2  justify-content-center gap-2'>
                      <Card
                        style={{ width: '48%' }}
                        className={clsx(
                          hoveredCard === '2'
                            ? 'menu-item col-md-3  p-3  text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                            : 'menu-item col-md-3  p-3  text-center  menu-link',
                          {
                            'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                              checkIsActive(pathname, 'pharmacy-sales'),
                          }
                        )}
                        onMouseEnter={() => handleMouseEnter('2')}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => navigate('pharmacy-sales')}
                      >
                        <Card.Body className='row p-0 justify-content-center'>
                          <Card.Subtitle className=''>
                            {/* <div className='row'>
                          <i style={{color: 'red'}} className=' fa-solid fa-arrow-up '></i>
                          <i style={{color: 'red'}}></i>
                        </div> */}
                            Pharmacy sales - Drugs associated with Respiratory Syndromes
                            <div className='row'>
                              {alertData?.drugSales.some((entry) => entry.alertVirus === 1) ? (
                                <OverlayTrigger
                                  placement='right'
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={<Tooltip id='button-tooltip-2'>All regions</Tooltip>}
                                >
                                  <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                </OverlayTrigger>
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )}
                            </div>
                          </Card.Subtitle>
                          <Col className='mb-5'>
                            <MyLineChart2
                              data={
                                dataGraph
                                  ? [
                                    {
                                      id: 'drugSalesRSAlerts',
                                      data: processData(
                                        dataGraph.drugSalesRSAlerts,
                                        selectedWeek
                                      ),
                                    },
                                  ]
                                  : []
                              }
                              percent={true}
                            />
                          </Col>
                        </Card.Body>
                      </Card>

                      <Card
                        style={{ width: '48%' }}
                        className={clsx(
                          hoveredCard === '3'
                            ? 'menu-item col-md-3 p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                            : 'menu-item col-md-3 p-3  text-center  menu-link',
                          {
                            'col-md-3 bg-primary  border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                              checkIsActive(pathname, 'doctor-visits'),
                          }
                        )}
                        onMouseEnter={() => handleMouseEnter('3')}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => navigate('doctor-visits')}
                      >
                        <Card.Body className='row  p-0  justify-content-center'>
                          <Card.Subtitle className='mb-10 '>
                            {/* <div className='row'>
                          <i style={{color: 'green'}} className='  fa-solid fa-arrow-down '></i>
                          <i style={{color: 'red'}}></i>
                        </div> */}
                            Doctor visits for Respiratory Syndromes
                            <div className='row'>
                              {alertData?.consultationNumber.some(
                                (entry) => entry.ageGroup === '0-200' && entry.alertVirus === 1
                              ) ? (
                                <OverlayTrigger
                                  placement='right'
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id='button-tooltip-2'>
                                      <i style={{ color: 'red' }}>All age groups</i>
                                    </Tooltip>
                                  }
                                >
                                  <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                </OverlayTrigger>
                              ) : alertData?.consultationNumber.some(
                                (entry) => entry.alertVirus === 1
                              ) ? (
                                <OverlayTrigger
                                  placement='right'
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id='button-tooltip-2'>
                                      {getAlertedAgeClasses(
                                        alertData?.consultationNumber ?? null
                                      )?.map((ageGroup, index) => {
                                        let readableAge = ''
                                        switch (ageGroup) {
                                          case '<1':
                                            readableAge = '(< 1 year)'
                                            break
                                          case '01-avr':
                                            readableAge = '(1-4 years)'
                                            break
                                          case 'mai-14':
                                            readableAge = '(5-14 years)'
                                            break
                                          case '15-34':
                                            readableAge = '(15-34 years)'
                                            break
                                          case '35-59':
                                            readableAge = '(35-59 years)'
                                            break
                                          case '60-79':
                                            readableAge = '(60-79 years)'
                                            break
                                          case '80+':
                                            readableAge = '(> 80 years)'
                                            break
                                          case '0-200':
                                            readableAge = ''
                                            break
                                        }
                                        return (
                                          <div key={index}>
                                            <i style={{ color: '#FF8400' }}>{readableAge}</i>
                                          </div>
                                        )
                                      })}
                                    </Tooltip>
                                  }
                                >
                                  <i style={{ color: '#FF8400' }} className='fa-solid fa-bell'></i>
                                </OverlayTrigger>
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )}
                            </div>
                          </Card.Subtitle>
                          <Col>
                            <MyLineChart2
                              data={
                                dataGraph
                                  ? [
                                    {
                                      id: 'consultationNumberRsAlerts',
                                      data: processData(
                                        dataGraph.consultationNumberRsAlerts,
                                        selectedWeek
                                      ),
                                    },
                                  ]
                                  : []
                              }
                              percent={true}
                            />
                          </Col>
                        </Card.Body>
                      </Card>
                    </Card.Body>
                  </Card>

                  <Card style={{ width: '20%' }} className='bg-primary  bg-opacity-10  col-md-4 '>
                    <Card.Title
                      style={{
                        width: '104%',
                        marginLeft: '-2%',
                        marginTop: '9px',
                        marginBottom: '-0.1%',
                      }}
                      className='text-center  bg-primary rounded bg-opacity-0 p-4'
                    >
                      Hospital
                    </Card.Title>
                    {/* <Card.Title
                  style={{width: '104%', marginLeft: '-2%'}}
                  className='text-center text-white  bg-primary rounded  p-4'
                >
                  Virology
                </Card.Title> */}
                    <Card.Body className='row  p-2  justify-content-center gap-2'>
                      <Card
                        style={{ width: '48%' }}
                        className={clsx(
                          hoveredCard === '4'
                            ? 'menu-item col-md-3  p-3  text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                            : 'menu-item col-md-3  p-3  text-center  menu-link',
                          {
                            'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                              checkIsActive(pathname, 'hospital-adminssions'),
                          }
                        )}
                        onMouseEnter={() => handleMouseEnter('4')}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => navigate('hospital-adminssions')}
                      >
                        <Card.Body className='row  p-0  justify-content-center'>
                          <Card.Subtitle className='mb-10 '>
                            {/* <div>
                          <i
                            style={{color: 'orange', transform: 'rotate(-30deg)'}}
                            className='  fa-solid fa-arrow-right '
                          ></i>
                          <i style={{color: 'red'}}></i>
                        </div> */}
                            Hospital admissions for SARI
                            <div className='row'>
                              {alertData?.hospitalAdmission.some(
                                (entry) => entry.ageGroup === '0_200' && entry.alertVirus === 1
                              ) ? (
                                <OverlayTrigger
                                  placement='right'
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id='button-tooltip-2'>
                                      <i style={{ color: 'red' }}>All age groups</i>
                                    </Tooltip>
                                  }
                                >
                                  <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                </OverlayTrigger>
                              ) : alertData?.hospitalAdmission.some(
                                (entry) => entry.alertVirus === 1
                              ) ? (
                                <OverlayTrigger
                                  placement='right'
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id='button-tooltip-2'>
                                      {getAlertedAgeClasses(
                                        alertData?.hospitalAdmission ?? null
                                      )?.map((ageGroup, index) => {
                                        let readableAge = ''
                                        switch (ageGroup) {
                                          case '0_4':
                                            readableAge = '(0-4 years)'
                                            break
                                          case '5_14':
                                            readableAge = '(5-14 years)'
                                            break
                                          case '15_34':
                                            readableAge = '(15-34 years)'
                                            break
                                          case '35_59':
                                            readableAge = '(35-59 years)'
                                            break
                                          case '60_79':
                                            readableAge = '(60-79 years)'
                                            break
                                          case 'More_80':
                                            readableAge = '(> 80 years)'
                                            break
                                          case '0_200':
                                            readableAge = ''
                                            break
                                        }
                                        return (
                                          <div key={index}>
                                            <i style={{ color: '#FF8400' }}>{readableAge}</i>
                                          </div>
                                        )
                                      })}
                                    </Tooltip>
                                  }
                                >
                                  <i style={{ color: '#FF8400' }} className='fa-solid fa-bell'></i>
                                </OverlayTrigger>
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )}
                            </div>
                          </Card.Subtitle>
                          <Col>
                            <MyLineChart2
                              data={
                                dataGraph
                                  ? [
                                    {
                                      id: 'hospitalAdmissionsSariAlerts',
                                      data: processData(
                                        dataGraph.hospitalAdmissionsSariAlerts,
                                        selectedWeek
                                      ),
                                    },
                                  ]
                                  : []
                              }
                            />
                          </Col>
                        </Card.Body>
                      </Card>

                      <Card
                        style={{ width: '48%' }}
                        className={clsx(
                          hoveredCard === '5'
                            ? 'menu-item col-md-3 p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                            : 'menu-item col-md-3 p-3  text-center  menu-link',
                          {
                            'col-md-3 bg-primary  border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                              checkIsActive(pathname, 'deaths-for-covid'),
                          }
                        )}
                        onMouseEnter={() => handleMouseEnter('5')}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => navigate('deaths-for-covid')}
                      >
                        <Card.Body className='row  p-0  justify-content-center'>
                          <Card.Subtitle className='mb-15 '>
                            {/* <div>
                          <i
                            style={{color: 'green', transform: 'rotate(15deg)'}}
                            className='  fa-solid fa-arrow-down '
                          ></i>
                          <i style={{color: 'red'}}></i>
                        </div> */}
                            Deaths for Covid-19
                            <div className='row'>
                              {alertData?.covidDeath.some(
                                (entry) => entry.ageGroup === '0-200' && entry.alertVirus === 1
                              ) ? (
                                <OverlayTrigger
                                  placement='right'
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id='button-tooltip-2'>
                                      <i style={{ color: 'red' }}>All age groups</i>
                                    </Tooltip>
                                  }
                                >
                                  <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                </OverlayTrigger>
                              ) : alertData?.covidDeath.some((entry) => entry.alertVirus === 1) ? (
                                <OverlayTrigger
                                  placement='right'
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id='button-tooltip-2'>
                                      {getAlertedAgeClasses(alertData?.covidDeath ?? null)?.map(
                                        (ageGroup, index) => {
                                          let readableAge = ''
                                          switch (ageGroup) {
                                            case '0-4':
                                              readableAge = '(0-4 years)'
                                              break
                                            case 'mai-14':
                                              readableAge = '(5-14 years)'
                                              break
                                            case '15-34':
                                              readableAge = '(15-34 years)'
                                              break
                                            case '35-59':
                                              readableAge = '(35-59 years)'
                                              break
                                            case '60-79':
                                              readableAge = '(60-79 years)'
                                              break
                                            case '80plus':
                                              readableAge = '(> 80 years)'
                                              break
                                            case '0-200':
                                              readableAge = ''
                                              break
                                          }
                                          return (
                                            <div key={index}>
                                              <i style={{ color: '#FF8400' }}>{readableAge}</i>
                                            </div>
                                          )
                                        }
                                      )}
                                    </Tooltip>
                                  }
                                >
                                  <i style={{ color: '#FF8400' }} className='fa-solid fa-bell'></i>
                                </OverlayTrigger>
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )}
                            </div>
                          </Card.Subtitle>
                          <Col>
                            <MyLineChart2
                              data={
                                dataGraph
                                  ? [
                                    {
                                      id: 'covid19DeathsAlerts',
                                      data: processData(
                                        dataGraph.covid19DeathsAlerts,
                                        selectedWeek
                                      ),
                                    },
                                  ]
                                  : []
                              }
                            />
                          </Col>
                        </Card.Body>
                      </Card>
                    </Card.Body>
                  </Card>
                  <Card style={{ width: '20%' }} className='bg-primary  bg-opacity-10  col-md-4 '>
                    <Card.Title
                      style={{
                        width: '104%',
                        marginLeft: '-2%',
                        marginTop: '9px',
                        marginBottom: '-0.1%',
                      }}
                      className='text-center  bg-primary rounded bg-opacity-0 p-4'
                    >
                      Virology
                    </Card.Title>
                    {/* <Card.Title
                  style={{width: '104%', marginLeft: '-2%'}}
                  className='text-center text-white  bg-primary rounded  p-4'
                >
                  Virology
                </Card.Title> */}
                    <Card.Body className='row  p-2  justify-content-center gap-2'>
                      <Card
                        style={{ width: '48%' }}
                        className={clsx(
                          hoveredCard === '6'
                            ? 'menu-item col-md-3  p-3  text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                            : 'menu-item col-md-3  p-3  text-center  menu-link',
                          {
                            'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                              checkIsActive(pathname, 'viruses-positivity-rate'),
                          }
                        )}
                        onMouseEnter={() => handleMouseEnter('6')}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => navigate('viruses-positivity-rate')}
                      >
                        <Card.Body className='row  p-0  justify-content-center'>
                          <Card.Subtitle className='mb-10 text-muted'>
                            {/* <div>
                          <i
                            style={{color: 'red', transform: 'rotate(15deg)'}}
                            className='  fa-solid fa-arrow-up '
                          ></i>
                          <i style={{color: 'red'}}></i>
                        </div> */}
                            Respiratory viruses positivity rate
                            <div className='row'>
                              <i className='fa-solid fa-bell opacity-0'></i>
                            </div>
                          </Card.Subtitle>
                          <Col>
                            <MyLineChart2
                              data={
                                dataGraph
                                  ? [
                                    {
                                      id: 'respiratoryVirusPositivityRatesAlerts',
                                      data: processData(
                                        dataGraph.respiratoryVirusPositivityRatesAlerts,
                                        selectedWeek
                                      ),
                                    },
                                  ]
                                  : []
                              }
                            />
                          </Col>
                        </Card.Body>
                      </Card>

                      <Card
                        style={{ width: '48%' }}
                        className={clsx(
                          hoveredCard === '7'
                            ? 'menu-item col-md-3 p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                            : 'menu-item col-md-3 p-3  text-center  menu-link',
                          {
                            'col-md-3 bg-primary  border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                              checkIsActive(pathname, 'viral-load-in-wastewater'),
                          }
                        )}
                        onMouseEnter={() => handleMouseEnter('7')}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => navigate('viral-load-in-wastewater')}
                      >
                        <Card.Body className='row  p-0  justify-content-center'>
                          <Card.Subtitle className='mb-10 text-muted'>
                            {/* <div>
                          <i
                            style={{color: 'green', transform: 'rotate(40deg)'}}
                            className='  fa-solid fa-arrow-right '
                          ></i>
                          <i style={{color: 'red'}}></i>
                        </div> */}
                            Viral Load in wastewater - Covid-19
                            <div className='row'>
                              <i className='fa-solid fa-bell opacity-0'></i>
                            </div>
                          </Card.Subtitle>
                          <Col>
                            <MyLineChart2
                              data={
                                dataGraph
                                  ? [
                                    {
                                      id: 'wastewaterViralLoadCovid19GeAlerts',
                                      data: processData(
                                        dataGraph.wastewaterViralLoadCovid19GeAlerts,
                                        selectedWeek
                                      ),
                                    },
                                  ]
                                  : []
                              }
                            />
                          </Col>
                        </Card.Body>
                      </Card>
                    </Card.Body>
                  </Card>
                </Col>
              </div>
            </div>

            <div className='row justify-content-center col-12'>
              <p className='text-center' style={{ color: '#FF8400', fontSize: '12px' }}>
                <i style={{ color: '#FF8400' }} className='fa-solid fa-bell'></i>{' '}
                <OverlayTrigger
                  placement='right'
                  overlay={
                    <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                      <p>
                        An alert appears if the current case count exceeds the upper bound of the
                        corresponding value for each week of the previous year(s) OR if the current
                        case count exceeds the upper bound of the average monthly case counts. An
                        alert does not necessarily reflect the current trend.
                      </p>
                    </Tooltip>
                  }
                >
                  <b>Alert for some age groups</b>
                </OverlayTrigger>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>{' '}
                <OverlayTrigger
                  placement='right'
                  overlay={
                    <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                      <p>
                        An alert appears if the current case count exceeds the upper bound of the
                        corresponding value for each week of the previous year(s) OR if the current
                        case count exceeds the upper bound of the average monthly case counts. An
                        alert does not necessarily reflect the current trend.
                      </p>
                    </Tooltip>
                  }
                >
                  <b style={{ color: 'red' }}>Alert all age groups</b>
                </OverlayTrigger>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <i style={{ color: 'black ' }} className='fa-solid fa-circle'></i>{' '}
                <OverlayTrigger
                  placement='right'
                  overlay={
                    <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                      <p>Data not available for the date considered</p>
                    </Tooltip>
                  }
                >
                  <b style={{ color: 'black' }}>Missing Data</b>
                </OverlayTrigger>
              </p>
              <Card.Title className='mx-8' style={{ marginTop: '-1%' }}>
                <h3 className='mb-5 text-start'>
                  Trends relative to the 2 previous weeks
                </h3>
              </Card.Title>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  )
}
